import React from "react";
import "assets/scss/helpers/buttons.scss";
import classNames from "classnames";
export default function ({
  onClick,
  name,
  type = "submit",
  disabled = false,
  buttonStyle,
  children,
  buttonClass = "grad_btn full_w h-50",
}) {
  const buttonClasses = classNames({
    btn: true,
    [buttonClass]: true,
  });
  return (
    <button
      style={buttonStyle}
      disabled={disabled}
      type={type}
      className={buttonClasses}
      onClick={onClick}
    >
      {name || children}
    </button>
  );
}
